import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { Avatar, AvatarFallback, AvatarImage } from '@ui/primitives';
import { getAbbreviation } from '@ui/utils';
import { Info } from 'lucide-react';
import { DateTime } from 'luxon';
const STATUS_KEYWORDS = [
    {
        word: 'production',
        className: 'text-green-600 dark:text-green-400'
    },
    {
        word: 'failed',
        className: 'text-red-600 dark:text-red-400'
    },
    {
        word: 'deprecated',
        className: 'text-amber-600 dark:text-amber-400'
    }
];
function formatRelativeTime(isoDate) {
    var _dt_toRelative;
    const dt = DateTime.fromISO(isoDate);
    return (_dt_toRelative = dt.toRelative()) !== null && _dt_toRelative !== void 0 ? _dt_toRelative : isoDate;
}
function highlightStatusWords(message) {
    const regex = new RegExp("\\b(".concat(STATUS_KEYWORDS.map((k)=>k.word).join('|'), ")\\b"), 'gi');
    const parts = message.split(regex);
    return parts.map((part, i)=>{
        const keyword = STATUS_KEYWORDS.find((k)=>part.toLowerCase() === k.word.toLowerCase());
        if (keyword) {
            return /*#__PURE__*/ _jsx("span", {
                className: keyword.className,
                children: part
            }, "".concat(keyword.word, "-").concat(i));
        }
        return part;
    });
}
export function AuditLogItem(param) {
    let { log, children } = param;
    var _log_author_avatarColor;
    const isFailure = log.result === 'failure';
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-3 border-b border-border py-3 last:border-b-0",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-10 w-10 shrink-0 items-center justify-center",
                children: isFailure ? /*#__PURE__*/ _jsx("div", {
                    className: "flex h-10 w-10 items-center justify-center rounded-full bg-muted",
                    children: /*#__PURE__*/ _jsx(Info, {
                        className: "h-5 w-5 text-muted-foreground",
                        "aria-hidden": true
                    })
                }) : /*#__PURE__*/ _jsx(Link, {
                    to: "/profile/$username",
                    params: {
                        username: log.author.username
                    },
                    className: "shrink-0",
                    children: /*#__PURE__*/ _jsxs(Avatar, {
                        className: "h-10 w-10",
                        children: [
                            log.author.portrait && /*#__PURE__*/ _jsx(AvatarImage, {
                                src: log.author.portrait,
                                alt: log.author.name
                            }),
                            /*#__PURE__*/ _jsx(AvatarFallback, {
                                style: {
                                    backgroundColor: (_log_author_avatarColor = log.author.avatarColor) !== null && _log_author_avatarColor !== void 0 ? _log_author_avatarColor : '#6b7280'
                                },
                                children: getAbbreviation(log.author.name)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1 text-sm text-muted-foreground",
                children: [
                    !isFailure && /*#__PURE__*/ _jsx(Link, {
                        to: "/profile/$username",
                        params: {
                            username: log.author.username
                        },
                        className: "font-medium text-foreground hover:underline",
                        children: log.author.name
                    }),
                    !isFailure && ' ',
                    highlightStatusWords(log.message),
                    /*#__PURE__*/ _jsx("span", {
                        className: "ml-4",
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "shrink-0 whitespace-nowrap text-xs text-muted-foreground",
                children: formatRelativeTime(log.createdAt)
            })
        ]
    });
}
